import { Alert, Box, capitalize, Stack, Typography } from "@mui/material";
import { t } from "i18next";
import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import {
  getScreens,
  selectScreensForPremise,
} from "../store/reducers/screenReducer";
import { CustomerPortalState, store } from "../store";
import { useSelector } from "react-redux";
import UnitList from "../components/Unit/UnitList";
import PermissionsGate from "../components/PermissionGate";
import { Resource, Scope } from "../../../../types/NendaTypes";
import CreateUnit from "../components/Unit/Create/CreateUnit";
import CenteredLoadingIndicator from "../ui-components/loading/CenteredLoadingIndicator";

const UnitListPage: React.FC = () => {
  const { premiseId } = useParams<{
    premiseId: string;
  }>();

  useEffect(() => {
    if (!premiseId) return;

    store.dispatch(getScreens(premiseId));
  }, [premiseId]);

  const isLoading = useSelector(
    (state: CustomerPortalState) => state.screen.isLoading
  );

  const screens = useSelector((state: CustomerPortalState) =>
    premiseId ? selectScreensForPremise(state, premiseId) : []
  );

  if (isLoading) return <CenteredLoadingIndicator />;

  return (
    <PermissionsGate
      restriction={{
        resource: Resource.Premise,
        scopes: [Scope.CanAdministrate],
      }}
    >
      <Box>
        <Stack
          sx={{ display: "flex", alignItems: "center" }}
          spacing={3}
          direction="row"
        >
          <Typography variant="h2">
            {capitalize(t("glossary.unit", { count: 2 }))}
          </Typography>
          <CreateUnit />
        </Stack>
        <Box>
          {screens.length === 0 ? (
            <Alert severity="info">
              {t("customerportal.pages.unit.not_found")}
            </Alert>
          ) : (
            <UnitList units={screens} />
          )}
        </Box>
      </Box>
    </PermissionsGate>
  );
};

export default UnitListPage;
